<lex-doc-viewer-dialog class="fontify-color-2" style="display: flex; flex-direction: column;">
  <div dialog-title>Custom AI Prompt</div>
  <div dialog-body>
    <div style="display: flex; flex-direction: row; width:100%; overflow: hidden;max-height: 350px;">
      <div class="prompt-list-column">
        <div class="header" style="justify-content: end; padding-top: 14px; gap: 8px; margin: 2px 12px 2px 0px; align-items: flex-start;">
          <lex-text-input *ngIf="!showEditList" placeholder="Search All Available" id="search-box" [type]="'search'" [formControl]="searchBox"
                          style="width: 100%;"></lex-text-input>
          <button (click)="showEditList=!showEditList" style="cursor:pointer; border: unset; background: unset"
                  matTooltip="Manage Prompts">
            <i class="fa-duotone fa-pen-to-square docs-node"></i>
          </button>
        </div>
        <div *ngIf="!showEditList" class="not-edit-list" style="width: 100%; gap: 1px; display: flex; flex-direction: column; overflow: auto; margin: 16px 0px; padding-bottom: 8px;">
          <div *ngFor="let prompt of localPrompts" (click)="select(prompt)" style="cursor: pointer;"
               [ngClass]="{'prompt-list-selected-item': selectedPrompt?.promptId === prompt.promptId , 'prompt-list-row-item': selectedPrompt?.promptId !== prompt.promptId }">
            <div style="display:flex; flex-direction: row; justify-content: space-between; align-items: center; height: 36px; padding: 0px 9px 0px 16px;">
              <div style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap;">{{prompt.title}}</div>
              <div *ngIf="prompt.isShared && !prompt.isPinned">
                <i class="fa-duotone fa-square-share-nodes docs-node"></i>
              </div>
              <div *ngIf="!prompt.isShared && prompt.isPinned">
                <i class="fa-duotone fa-thumbtack docs-node"></i>
              </div>
              <div *ngIf="!prompt.isShared && !prompt.isPinned">
                <i class="fa-duotone fa-clock-rotate-left docs-node"></i>
              </div>
            </div>
          </div>
        </div>
        <mat-list *ngIf="showEditList" dense style="overflow: auto; padding-bottom: 8px;">
          <div class="grey-header" style="padding-right: 7px">
            <div class="grey-header-left">Shared</div>
            <i class="fa-duotone fa-share-nodes grey-header-right"></i>
          </div>
          <mat-list style="overflow: hidden;">
            <mat-list-item *ngFor="let prompt of sharedPrompts"
                           [ngClass]="{'prompt-list-selected-item': selectedPrompt?.promptId === prompt.promptId , 'prompt-list-row-item': selectedPrompt?.promptId !== prompt.promptId }"
                           (click)="select(prompt)">
              <div class="icon-button-line">
                <div mat-line> {{prompt.title}} </div>
                <button mat-icon-button [matMenuTriggerFor]="shared_action_menu" (click)="$event.stopPropagation()"
                        class="more-vert-button">
                  <div>
                    <i class="fa-solid fa-ellipsis-vertical grey-header-right more-vert-icon"></i>
                  </div>
                </button>
              </div>
              <mat-menu #shared_action_menu>
                <div [ngClass]="{'dark-theme-menu-item dark-theme': isDarkMode()}">
                  <button mat-menu-item [disabled]="prompt.createdById !== currentUserId" class="more-action-button"
                          (click)="unshareOrUnpinPrompt(prompt)">Unshare</button>
                  <button mat-menu-item [disabled]="prompt.createdById !== currentUserId" class="more-action-button"
                          (click)="pinPrompt(prompt)">Pin</button>
                  <button mat-menu-item [disabled]="prompt.createdById !== currentUserId" class="more-action-button"
                          (click)="deletePrompt(prompt)">Delete</button>
                </div>
              </mat-menu>
              <mat-divider></mat-divider>
            </mat-list-item>
          </mat-list>
          <div class="grey-header-below" style="padding-right: 7px">
            <div class="grey-header-left">Pinned</div>
            <i class="fa-duotone fa-thumbtack grey-header-right"></i>
          </div>
          <mat-list style="overflow: hidden;">
            <mat-list-item *ngFor="let prompt of pinnedPrompts"
                           [ngClass]="{'prompt-list-selected-item': selectedPrompt?.promptId === prompt.promptId , 'prompt-list-row-item': selectedPrompt?.promptId !== prompt.promptId }"
                           (click)="select(prompt)">
              <div class="icon-button-line">
                <div mat-line> {{prompt.title}} </div>
                <button mat-icon-button [matMenuTriggerFor]="pinned_action_menu" (click)="$event.stopPropagation()"
                        class="more-vert-button">
                  <div>
                    <i class="fa-solid fa-ellipsis-vertical grey-header-right more-vert-icon"></i>
                  </div>
                </button>
              </div>
              <mat-menu #pinned_action_menu>
                <div [ngClass]="{'dark-theme-menu-item dark-theme': isDarkMode()}">
                  <button mat-menu-item [disabled]="prompt.createdById !== currentUserId" class="more-action-button"
                          (click)="sharePrompt(prompt)">Share</button>
                  <button mat-menu-item [disabled]="prompt.createdById !== currentUserId" class="more-action-button"
                          (click)="unshareOrUnpinPrompt(prompt)">Unpin</button>
                  <button mat-menu-item [disabled]="prompt.createdById !== currentUserId" class="more-action-button"
                          (click)="deletePrompt(prompt)">Delete</button>
                </div>
              </mat-menu>
              <mat-divider></mat-divider>
            </mat-list-item>
          </mat-list>
          <div class="grey-header-below" style="padding-right: 7px">
            <div class="grey-header-left">Recent</div>
            <i class="fa-duotone fa-clock-rotate-left grey-header-right"></i>
          </div>
          <mat-list style="overflow: hidden;">
            <mat-list-item *ngFor="let prompt of recentPrompts"
                           [ngClass]="{'prompt-list-selected-item': selectedPrompt?.promptId === prompt.promptId , 'prompt-list-row-item': selectedPrompt?.promptId !== prompt.promptId }"
                           (click)="select(prompt)">
              <div class="icon-button-line">
                <div mat-line> {{prompt.title}} </div>
                <button mat-icon-button [matMenuTriggerFor]="recent_action_menu" (click)="$event.stopPropagation()"
                        class="more-vert-button">
                  <div>
                    <i class="fa-solid fa-ellipsis-vertical grey-header-right more-vert-icon"></i>
                  </div>
                </button>
              </div>
              <mat-menu #recent_action_menu>
                <div [ngClass]="{'dark-theme-menu-item dark-theme': isDarkMode()}">
                  <button mat-menu-item [disabled]="prompt.createdById !== currentUserId" class="more-action-button"
                          (click)="sharePrompt(prompt)">Share</button>
                  <button mat-menu-item [disabled]="prompt.createdById !== currentUserId" class="more-action-button"
                          (click)="pinPrompt(prompt)">Pin</button>
                  <button mat-menu-item [disabled]="prompt.createdById !== currentUserId" class="more-action-button"
                          (click)="deletePrompt(prompt)">Delete</button>
                </div>
              </mat-menu>
              <mat-divider></mat-divider>
            </mat-list-item>
          </mat-list>
        </mat-list>
      </div>
      <div class="column" style="margin: 0px 10px 0px 10px;">
        <div class="header" style="margin-top: 10px;">
          <h2>Details</h2>
        </div>
        <div>
          <form [formGroup]="promptForm" class="column" style="gap: 16px;">
            <lex-text-input placeholder="Prompt Title" label="Title"
                            [formControl]="promptForm.get('title')" [disabled]="promptForm.get('title').disabled"></lex-text-input>
            <lex-text-input [type]="'textarea'" [autoSizeTextarea]="true" rows=8 [formControl]="promptForm.get('fullPrompt')" [disabled]="promptForm.get('fullPrompt').disabled"></lex-text-input>
            <lex-checkbox class="check-box-label" label="Summary Prompt" [formControl]="promptForm.get('isSummaryPrompt')"></lex-checkbox>
          </form>
        </div>
        <div style="display:flex; float: right; justify-content:end; margin: 10px 0px;">
          <lex-flat-button [disabled]="disableSave()" *ngIf="displaySave()" (click)="save()" label="Save"
                           [type]="'action'" [icon]="'fa-duotone fa-check-double'"></lex-flat-button>
        </div>
      </div>
    </div>
  </div>
</lex-doc-viewer-dialog>